import React, { useEffect, useState, useMemo } from "react";
import apiService, { handleError } from "../../../Common/ApiCommon/ApiService";

const useCollectionTable = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(15);
  const [collectionReport, setCollectionReport] = useState();
  const [loading, setLoading] = useState(false);
  const [selectedFilter, setSelectedFilter] = useState("");
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);

  const formatDate = (date) => {
    if (!date) return null;
    return date.toString();
  };

  const getDateRange = (filter) => {
    const today = new Date();
    let fromDate, toDate;

    if (filter === "today") {
      fromDate = toDate = today;
    } else if (filter === "weekly") {
      fromDate = new Date(today);
      fromDate.setDate(today.getDate() - 7);
      toDate = today;
    } else if (filter === "monthly") {
      fromDate = new Date(today.getFullYear(), today.getMonth(), 1);
      toDate = today;
    }

    return {
      fromDate: formatDate(fromDate),
      toDate: formatDate(toDate),
    };
  };
  const fetchCollectiions = async () => {
    setLoading(true);
    try {
      let filterQuery = "";
      let from_date = fromDate;
      let to_date = toDate;

      if (
        selectedFilter === "today" ||
        selectedFilter === "weekly" ||
        selectedFilter === "monthly"
      ) {
        const range = getDateRange(selectedFilter);
        from_date = range.fromDate;
        to_date = range.toDate;
      } else if (selectedFilter === "custom" && fromDate && toDate) {
        from_date = formatDate(fromDate);
        to_date = formatDate(toDate);
      }

      filterQuery = `&date_filter=${selectedFilter}&start_date=${from_date}&end_date=${to_date}`;
      const response = await apiService.get(
        `/reports/collection_report?${filterQuery}`
      );
      setCollectionReport(response.data);
    } catch (errors) {
      handleError(errors);
      setCollectionReport([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCollectiions();
  }, [selectedFilter, fromDate, toDate]);

  // Define the columns
  const columns = React.useMemo(
    () => [
      { Header: "Date", accessor: "date" },
      { Header: "User Name", accessor: "username", width: "147px" },
      {
        Header: "Login/Logout Time",
        accessor: "login_logout_time",
        Cell: ({ value }) => {
          const [login, logout] = value.split(" / ");
          return (
            <div>
              <p className="text-nowrap">{login}</p>
              <p className="text-nowrap">{logout}</p>
            </div>
          );
        },
      },
      { Header: "Total Collection", accessor: "totalcollection" },
      { Header: "Total Received", accessor: "totalreceived" },
      { Header: "Cash", accessor: "cash" },
      { Header: "UPI", accessor: "upi" },
      { Header: "Card", accessor: "card" },
      { Header: "Cash Drawer Balance", accessor: "drawer_balance" },
    ],
    []
  );


  // Sample data
  const data = useMemo(() => {
    if (!collectionReport) return [];
    console.log("collectionReport", collectionReport);
    return collectionReport?.flatMap((report) =>
      report.staff.map((staffMember) => {
        const loginTime = staffMember.check_in
          ? new Date(staffMember.check_in).toLocaleTimeString("en-IN", {
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
          })
          : "-";
        const logoutTime = staffMember.check_out
          ? new Date(staffMember.check_out).toLocaleTimeString("en-IN", {
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
          })
          : "-";
        return {
          date: report.date,
          username: staffMember.full_name,
          loginTime,
          logoutTime,
          login_logout_time: `${loginTime} / ${logoutTime}`,  // Added here
          totalcollection: staffMember.total_collection,
          totalreceived: staffMember.total_received,
          cash: staffMember.cash,
          upi: staffMember.upi,
          card: staffMember.card,
          drawer_balance: staffMember.drawer_balance ?? "-",
        };
      })
    );

  }, [collectionReport]);

  console.log("collectionReport", collectionReport);
  console.log("data", data);

  // Paginate the data
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = data?.slice(indexOfFirstRow, indexOfLastRow);

  // Handle page change
  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  // Handle rows per page change
  const handleRowsPerPageChange = (newRowsPerPage) => {
    setRowsPerPage(newRowsPerPage);
    setCurrentPage(1); // Reset to page 1 when rows per page change
  };

  return {
    columns,
    currentRows,
    totalRows: data.length,
    currentPage,
    rowsPerPage,
    handlePageChange,
    handleRowsPerPageChange,
    loading,
    selectedFilter,
    setSelectedFilter,
    setFromDate,
    setToDate,
    fromDate,
    toDate,
    data
  };
};

export default useCollectionTable;
